import { render, staticRenderFns } from "./UserInvoices.vue?vue&type=template&id=2e2f032a&scoped=true&"
import script from "./UserInvoices.vue?vue&type=script&lang=js&"
export * from "./UserInvoices.vue?vue&type=script&lang=js&"
import style0 from "./UserInvoices.vue?vue&type=style&index=0&id=2e2f032a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2f032a",
  null
  
)

export default component.exports